import React from 'react';

const HeaderBar = ({ title, rightIcons = [] }) => {
  return (
    <div className="p-4 bg-white shrink-0">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">{title}</h1>

        {/* 오른쪽: 최대 3개의 아이콘 */}
        <div className="flex items-center space-x-2">
          {rightIcons.slice(0, 3).map((iconConfig, index) => (
            <button
              key={index}
              onClick={iconConfig.onClick}
              className="p-2 active:bg-gray-100 rounded-full"
              disabled={iconConfig.disabled}
              title={iconConfig.title}
            >
              {iconConfig.icon}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeaderBar;
